// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__E3N1s","dividerInner":"Divider_dividerInner__wFiBy"};